export const USER_MANAGEMENT_CONSTANTS = {
  DEFAULT_USERS_PER_PAGE: 7,
  DEFAULT_SIDEBAR_WIDTH: '350px',
  SIDEBAR_MIN_WIDTH: 250,
  SIDEBAR_MAX_WIDTH_RATIO: 0.6,
  CONTAINER_HEIGHT: '95vh',
  SNACKBAR_DURATION: 6000,
  SEARCH_RESULTS_LIMIT: 100
} as const;